<mat-expansion-panel>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <div class="row gap-8 align-center">
                <img
                    *ngIf="category.image"
                    class="image-icon"
                    [src]="
                        frontendurl +
                        '/public/catimages/thumbs/' +
                        category.image
                    "
                />
                <rr-badge>{{ category.status }}</rr-badge>
                <div>
                    {{ category.name }}
                </div>
            </div>
        </mat-panel-title>

        <mat-panel-description class="panel-description">
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="w100 col gap-24">
        <div class="row gap-8 w100 align-end justify-end">
            <div class="category-actions">
                <rr-icon
                    name="edit"
                    (click)="editPackage.emit(category)"
                    class="edit"
                ></rr-icon>
                <rr-icon
                    name="trash"
                    (click)="deletePackage.emit(category.id)"
                    class="delete"
                ></rr-icon>
            </div>
        </div>

        <div
            class="children-container col gap-8 w100"
            i18n
            cdkDropList
            (cdkDropListDropped)="drop($event)"
        >
            <h4>Streams</h4>
            @for (stream of filteredStreams; track stream.id) {
                <div class="row w100 card pointer" cdkDrag>
                    {{ stream.name }}
                </div>
            }
        </div>
    </div>
</mat-expansion-panel>
